<section class="nw-author-block">
    <div class="nw-author-block__container">
        @if (pictureurl && picturealt) {
            <img
                class="nw-author-block__container__image"
                [ngSrc]="pictureurl"
                [alt]="picturealt"
                height="48"
                width="48"
            />
        } @else {
            <div
                class="nw-author-block__container__image nw-author-block__container__image--empty"
            ></div>
        }

        @if (jobtitle && (timeToRead || formattedDate)) {
            <h5 class="nw-author-block__container__title">
                {{ name }}&#44;&nbsp;{{ jobtitle }}
            </h5>
        } @else {
            <h5 class="nw-author-block__container__title">
                {{ name }}
            </h5>
        }

        @if (timeToRead || formattedDate) {
            <div class="nw-author-block__container__desc">
                {{ !!timeToRead ? timeToRead + ' min read' : ''
                }}{{
                    !!formattedDate
                        ? (!!timeToRead ? ' - ' : '') + 'Published on ' + formattedDate
                        : undefined
                }}
            </div>
        } @else if (jobtitle) {
            <div class="nw-author-block__container__desc">
                {{ jobtitle }}
            </div>
        }
    </div>
</section>
